<template>
	<div>
		<div v-if="modoTarjeta">
			<div class="card font-12 font-blue-1 card-producto mx-1">
				<div v-show="mostrarTag == undefined || mostrarTag == true">
					<div class="tag-nuevo" v-if="item.nuevo && !item.buenFin">NUEVO</div>
					<div class="tag-oferta" v-if="item.ofertado && !item.buenFin">OFERTA</div>
					<div class="tag-remate" v-if="item.remate && !item.buenFin">REMATE</div>
					<div class="tag-remate" v-if="item.buenFin">BUEN FIN</div>
				</div>
				<div class="d-flex justify-content-center">
					<img 
					v-if="item.buenFin"
					class="logo-buenfin"
					src="@/assets/img-priv/bfxs.png" 
					alt="buen-fin"
					>
						<div>
							<a @click="mostrarDetalle" class="position-relative cursor-pointer w-100" role="button"> 
								<img
								:src="imagenOptima(item)"
								@error="imagenDefault(item)"					
								class="card-img-top card-producto-img mx-auto my-2"
								/>
							</a>				
						</div>
				</div>

				<img class="img-generico" src="@/assets/img-priv/icon_generico.png" v-if="item.gi" />
				<div :class="item.buenFin ? 'card-body buen-finbg' : 'card-body'">
					<hr />
					<div class="font-weight-bold font-poppins">{{item.descripcion}}</div>
					<div class="font-weight-bolder ml-2">{{item.generico}}</div>
					<div class="font-poppins ml-2">Laboratorio: {{item.marca}}</div>
					<hr />
					<div class="d-flex">
						<div class="text-left">
							<div>
								<img class="ml-2 imgBox" src="@/assets/img-priv/box.png"/>								
								<span class="ml-1 font-weight-bolder">Colectivo: {{item.empColectivo}} pzas.</span>
								<!-- <span class="font-10 ml-1">Unidades</span> -->
							</div>	
						</div>
						<div class="text-right ml-auto" v-show="item.tipoControl == 1">
							<i class="icon-trazado-1109 fa-lg"></i>
							{{item.temperatura}}
						</div>
					</div>

					<hr />
					<div class="d-flex">
						<div>
							<span class="mr-1 ml-2">Mi precio:</span>
							<span class="font-14 font-weight-bold">{{item.precioNeto | format-number('$0,0.00')}}</span>
							<span v-if="item.ofertado || item.remate || item.buenFin" v-text="cantidadDescuento(item)" class="ml-1 px-1 border-radius-1 font-12 bg-remate"></span>
							<div class="background-green-1 border-radius-1 px-2" v-show="item.ofertado && !item.remate && !item.buenFin">
									<div>
										<span class="mr-1">Oferta:</span>
										<span class="mr-3 font-14 font-weight-bold">{{item.precioOfertado | format-number('$0,0.00')}}</span>
									</div>
									<div v-if="item.minimoPiezas > 1">
										<span class="mr-1 font-10">Compra mínima: {{item.minimoPiezas | format-number('0,0')}} pzas.</span>
									</div>
								</div>
								<div class="bg-remate border-radius-1 px-2" v-show="(item.remate) && (!item.ofertado && !item.buenFin)">
									<div>
										<span class="mr-1">Remate:</span>
										<span class="mr-3 font-14 font-weight-bold">{{item.precioRemate | format-number('$0,0.00')}}</span>
									</div>
									<div v-if="item.minimoPiezas > 1">
										<span class="mr-1 font-10">Compra mínima: {{item.minimoPiezas | format-number('0,0')}} pzas.</span>
									</div>
								</div>
							<div class="bg-remate border-radius-1 px-2" 
								v-show="(item.buenFin) || (item.buenFin && item.ofertado) || (item.buenFin && item.remate)">
								<span class="mr-1">Buen Fin:</span>
								<span class="font-14 font-weight-bold">{{item.precioBuenFin | format-number('$0,0.00')}}</span>
							</div>
						</div>

						<div class="text-right ml-auto">
							<img class="img-clasificacion" src="@/assets/img-priv/icon_pp.png" v-if="item.pp" />
							<img class="img-clasificacion" src="@/assets/img-priv/icon_ftp.png" v-if="item.ftp" />
							<img class="img-clasificacion" src="@/assets/img-priv/icon_mdp.png" v-if="item.mdp" />
							<img class="img-clasificacion" src="@/assets/img-priv/icon_otc.png" v-if="item.otc" />
							<img class="img-clasificacion" src="@/assets/img-priv/icon_psp.png" v-if="item.psp" />
						</div>
					</div>
					<hr />				
					<div class="ml-2 mt-1">							
						<div class="font-weight-bold mb-1">
							Existencia:
						</div>							
						<div>
							<div>
								<span class="font-weight-bold">{{ usuarioGlobal().sucursal }}:</span>
								<span class="mx-2">{{item.existenciaMiCedis | format-number('0,0')}}</span>

								<span class="ml-3 font-weight-bold">Otros CEDIS:</span>
								<span class="mx-2">{{item.existenciaOtrosCedis | format-number('0,0')}}</span>
							</div>								
						</div>
					</div>
					<div v-if="(item.existenciaMiCedis > 0 && (item.ofertado || item.remate)) || !item.sinDerechoDevolucion" class="row">
						<div class="col-19 mt-2 ml-3 mb-1 div-fechacaducidad">
							<div v-if="item.existenciaMiCedis > 0 && (item.ofertado || item.remate)" class="">
								<span class="mr-1 font-14">Fecha de caducidad: {{item.fechaCaducidad | format-date('DD/MMM/YYYY') }}</span>
							</div>
							<div v-if="!item.sinDerechoDevolucion" class="">
								<span  class="mr-1 font-14">Producto con derecho a devolución</span>
							</div>
						</div>
					</div>
					<div style="text-align: left;" class="texto-producto-sin-devolucion mx-2" v-if="item.sinDerechoDevolucion">* Producto sin derecho a devolución</div>
					<div class="text-right">
						<a @click="mostrarDetalle" class="cursor-pointer" role="button">
							<i class="fas fa-plus-circle"></i> Detalle de producto
						</a>
					</div>	
					<div>
						<div class="input-group mt-2">
							<input
								@blur="agregarCantidad"
								@focus="backupCantidad"
								@keyup.enter="agregarCantidad"
								class="form-control form-control-sm"
								ref="inputCantidad"
								type="text"
								v-model="item.cantidad"
								v-number
							/>
							<div class="input-group-append">
								<button
									@click="agregarCantidad"
									class="btn font-10 text-white w-105"
									:class="item.cantidad > 0 ? 'bg-success' : 'btn-blue-1'"
									type="button"
								>{{item.cantidad > 0 ? 'Agregado':'Añadir al carrito'}} </button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- modo listado -->
		<div v-else>
			<div class="font-12 col-producto font-blue-1 mx-1">
				<div v-show="mostrarTag == undefined || mostrarTag == true">
					<div class="tag-nuevo" v-if="item.nuevo && !item.buenFin">NUEVO</div>
					<div class="tag-oferta" v-if="item.ofertado && !item.buenFin" >OFERTA</div>
					<div class="tag-remate" v-if="item.remate && !item.buenFin">REMATE</div>
					<div class="tag-remate" v-if="item.buenFin">BUEN FIN</div>
				</div>
				
				<div class="d-flex">
					<div class="col-img d-flex align-items-center">
						<img 
						v-if="item.buenFin"
						class="logo-buenfin"
						src="@/assets/img-priv/bfxs.png" 
						alt="buen-fin"
						>
						<div>
							<a @click="mostrarDetalle" class="cursor-pointer" role="button">
							<img
								:src="imagenOptima(item)"
								@error="imagenDefault(item)"
								class="card-img-top card-producto-img-sm mx-auto my-2"
							/>
							</a>
							<img class="img-generico-sm" src="@/assets/img-priv/icon_generico.png" v-if="item.gi" />
						</div>
						
					</div>
					<div :class="item.buenFin ? 'ml-auto w-100 p-3 buen-finbg' : 'ml-auto w-100 p-3'">
						<div class="font-weight-bold font-poppins">{{item.descripcion}}</div>
						<div class="font-weight-bolder ml-2">{{item.generico}}</div>
						<div class="font-poppins ml-2">Laboratorio: {{item.marca}}</div>
						<div class="d-flex align-items-end">
							<div class="text-left">
								<div>
									<img class="ml-2 imgBox" src="@/assets/img-priv/box.png"/>
									<span class="ml-1 font-weight-bolder">Colectivo: {{item.empColectivo}} pzas.</span>
									<!-- <span class="font-10 ml-1">Unidades</span> -->
								</div>
							</div>

							<div class="text-right ml-auto" v-show="item.tipoControl == 1">
								<i class="icon-trazado-1109 fa-lg"></i>
								{{item.temperatura}}
							</div>

							<div class="text-right ml-auto">
								<img class="img-clasificacion-sm" src="@/assets/img-priv/icon_pp.png" v-if="item.pp" />
								<img class="img-clasificacion-sm" src="@/assets/img-priv/icon_ftp.png" v-if="item.ftp" />
								<img class="img-clasificacion-sm" src="@/assets/img-priv/icon_mdp.png" v-if="item.mdp" />
								<img class="img-clasificacion-sm" src="@/assets/img-priv/icon_otc.png" v-if="item.otc" />
								<img class="img-clasificacion-sm" src="@/assets/img-priv/icon_psp.png" v-if="item.psp" />
							</div>
						</div>
						<div class="ml-2 mt-1">								
							<div class="font-weight-bold mb-1">
								Existencia:
							</div>							
							<div>
								<div>
									<span class="font-weight-bold">{{ usuarioGlobal().sucursal }}:</span>
									<span class="mx-2">{{item.existenciaMiCedis | format-number('0,0')}}</span>

									<span class="ml-3 font-weight-bold">Otros CEDIS:</span>
									<span class="mx-2">{{item.existenciaOtrosCedis | format-number('0,0')}}</span>
								</div>								
							</div>
						</div>
						<!--<div class="text-right">
							<a @click="mostrarDetalle" class="cursor-pointer" role="button">
								<i class="fas fa-plus-circle"></i> Detalle de producto
							</a>
						</div>-->
						<div v-if="(item.existenciaMiCedis > 0 && (item.ofertado || item.remate)) || !item.sinDerechoDevolucion" class="row col-12">
							<div class="col-lg-7 col-md-9 ml-2 mt-1 mb-1 div-fechacaducidad">
								<div v-if="item.existenciaMiCedis > 0 && (item.ofertado || item.remate)" class="col-12">
									<span class="mr-1 font-12">Fecha de caducidad: {{item.fechaCaducidad | format-date('DD/MMM/YYYY') }}</span>
								</div>
								<div v-if="!item.sinDerechoDevolucion" class="col-12">
									<span class="mr-1 font-12">Producto con derecho a devolución</span>
								</div>
							</div>
						</div>
						<div class="row d-flex justify-content-between">
							<div class="text-left texto-producto-sin-devolucion">
								<span v-if="item.sinDerechoDevolucion" class="ml-2">* Producto sin derecho a devolución</span>
							</div>
							<div class="text-right detallesProducto">
								<a @click="mostrarDetalle" class="cursor-pointer mr-sm-3 mr-lg-3 mr-xl-2" role="button">
									<i class="fas fa-plus-circle"></i> Detalle de producto
								</a>
							</div>
						</div>
						<hr />
						<div class="row d-flex">
							<div>
								<span class="mr-1 ml-2">Mi precio:</span>
								<span class="font-14 font-weight-bold">{{item.precioNeto | format-number('$0,0.00')}}</span>
								<span v-if="item.ofertado || item.remate || item.buenFin" v-text="cantidadDescuento(item)" class="ml-1 px-1 border-radius-1 font-12 bg-remate"></span>
								<div class="background-green-1 border-radius-1 px-2" v-show="item.ofertado && !item.remate && !item.buenFin">
									
										<span class="mr-1">Oferta:</span>
										<span class="mr-3 font-14 font-weight-bold">{{item.precioOfertado | format-number('$0,0.00')}}</span>
										<span v-if="item.minimoPiezas > 1" class="mr-1 font-10">Compra mínima: {{item.minimoPiezas | format-number('0,0')}} pzas.</span>
									
								</div>
								<div class="bg-remate border-radius-1 px-2" v-show="(item.remate) && (!item.ofertado && !item.buenFin)">
									
										<span class="mr-1">Remate:</span>
										<span class="mr-3 font-14 font-weight-bold">{{item.precioRemate | format-number('$0,0.00')}}</span>
										<span v-if="item.minimoPiezas > 1" class="mr-1 font-10">Compra mínima: {{item.minimoPiezas | format-number('0,0')}} pzas.</span>
									
								</div>
								<div class="bg-remate border-radius-1 px-2" v-show="(item.buenFin) || (item.buenFin && item.ofertado) || (item.buenFin && item.remate)">
									<span class="mr-1">Buen Fin:</span>
									<span class="font-14 font-weight-bold">{{item.precioBuenFin | format-number('$0,0.00')}}</span>
								</div>
							</div>

							<div class="col-sm-6 ml-auto">
								<div class="input-group mt-2">
									<input
										@blur="agregarCantidad"
										@focus="backupCantidad"
										@keyup.enter="agregarCantidad"
										class="form-control form-control-sm"
										ref="inputCantidad"
										type="text"
										v-model="item.cantidad"
										v-number
									/>
									<div class="input-group-append">
										<button
											@click="agregarCantidad"
											class="btn font-10 text-white w-105"
											:class="item.cantidad > 0 ? 'bg-success' : 'btn-blue-1'"
											type="button"
										>{{item.cantidad > 0 ? 'Agregar':'Añadir al carrito'}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["item", "modoTarjeta", "mostrarTag"],
		data() {
			return {
				busquedaAvanzada: true,
				cantidadBackup: 0
			}

		},		
		mounted() {
			if (!this.item.cantidad) {
				this.item.cantidad = 0
			}
		},
		methods: {
			agregarCantidad() {
				//console.log('cantidad: ', this.item.cantidad)
				
				if(this.isNumeric(this.item.cantidad)==false){
					this.item.cantidad=this.cantidadBackup
				}
				else{
					if (this.cantidadBackup != this.item.cantidad) {
						
						if(this.item.cantidad==0){
							let msgText = '¿Desea quitar del carrito el producto: ' + this.item.descripcion + '?'

							this.$msg.question( msgText )
							.then((result) => {
								if (result.isConfirmed) {
									this.cantidadBackup = this.item.cantidad
									this.$emit("agregarCantidad", this.item)
								}
								else{
									this.item.cantidad=this.cantidadBackup
								}
							})
						}
						else{							
							this.cantidadBackup = this.item.cantidad
							this.$emit("agregarCantidad", this.item)
						}
					}
				}
			},
			backupCantidad() {
				//console.log(this.$refs.inputCantidad)
				this.$refs.inputCantidad.select()
				this.cantidadBackup = this.item.cantidad
			},
			imagenOptima(item) {
				return item.urlImagen + this.imgExtension()
			},
			imagenDefault(item) {
				item.urlImagen = "http://www.difarmer.com/imagenes/difarmer/no_imagen"
				return false
			},
			mostrarDetalle() {
				this.$emit("mostrarDetalle", this.item.codArticulo)
			},
			isNumeric: function (n) {
				return !isNaN(parseFloat(n)) && isFinite(n)
			},
			cantidadDescuento(item){
				let precioRemateOferta = 0;
				if(item.ofertado && !item.remate && !item.buenFin)
					precioRemateOferta = item.precioOfertado
				else if((item.remate) && (!item.ofertado && !item.buenFin))
					precioRemateOferta = item.precioRemate
				else if(item.buenFin)
					precioRemateOferta = item.precioBuenFin

				let r = (((item.precioNeto - precioRemateOferta) / item.precioNeto) * 100)
				r = r < 1.00 ? r.toFixed(2) : parseInt(Math.round(r))
				
				return "-" + r.toString() + "% "

			}
		}
	}
</script>
<style>
	.div-fechacaducidad{
		border: 1px solid #4fc147;
		padding: 3px; 
		border-radius: 3px;
		/* text-align: left; */
		color: #4fc147;
		font-weight: bold;
	}
	.logo-buenfin{
		position: absolute;
		top: 40px;
		left: 10px;
		z-index: 1;
	}

	.buen-finbg{
		background-color: rgb(255, 233, 233);
	}

	.w-105{
		width:105px;
	}
	.bg-remate{
		background: #ff0000;
		color: white;
	}

	.cursor-pointer {
		cursor: pointer !important;
		transition: all 0.3s ease;
	}

	.cursor-pointer:hover {
		font-size: 1.1em;
	}

	.col-producto {
		padding: 0px !important;
		position: relative;
		display: -ms-flexbox;
		display: -webkit-box;
		display: flex;
		-ms-flex-direction: column;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		background-color: #fff;
		flex-direction: column;
		min-width: 0;
		word-wrap: break-word;
		background-clip: border-box;
		border: 1px solid rgba(0, 0, 0, 0.125);
		border-radius: 0.25rem;
	}

	.col-img {
		border-right: 0.3em solid #eee;
		padding: 1em;
	}

	.card-producto {
		width: 350px;
	}

	hr {
		/*border: 1px solid #273c6e;*/
		border-color: #273c6e;
		font-weight: 400;
		margin-top: 0.5em;
		margin-bottom: 0.5em;
	}

	.card-producto > .card-body {
		padding: 1em;
	}

	.card-producto-img {
		height: 160px;
		width: 160px;
		margin: 0.4em;
	}

	.card-producto-img-sm {
		height: 150px;
		width: 150px;
	}

	.img-clasificacion {
		width: 44px;
		height: 44px;
	}

	.img-clasificacion-sm {
		width: 22px;
		height: 22px;
		margin-right: 0.3em;
	}

	.img-generico {
		width: 26px;
		height: 26px;
		position: absolute;
		top: 150px;
		right: 10px;
	}

	.img-generico-sm {
		width: 26px;
		height: 26px;
		position: absolute;
		bottom: 10px;
		left: 95px;
	}

	.imgBox{
		width: 20px;
		height: 21px;
	}

	.texto-producto-sin-devolucion {
		font-size: 12px;
		margin-left: 15px;
		font-family: "Open Sans";
		color: #ff0000;
		font-weight: bold;
	}
	
	@media screen and (min-width: 1500px) and (max-width: 3000px) {
		.detallesProducto {
			margin-right: 6px;
		}
	}
	
</style>